import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiRouter } from '../../global/routes/api-routes';
import { PlanDocumentKey, PlanDocumentKeyResult } from '../interfaces/plan-docs-interfaces';

@Injectable({
  providedIn: 'root',
})
export class PlanDocumentsService {
  headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'x-response-version': '2',
  };

  downloadHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/pdf',
    'x-response-version': '2',
  };

  httpOptions = {
    headers: new HttpHeaders({
      ...this.headers,
    }),
    withCredentials: true,
  };

  constructor(private httpClient: HttpClient) {}

  // search for plan key based on plan number
  searchPlanDocumentKey(planNumber: string): Observable<PlanDocumentKey> {
    const url = ApiRouter.searchPlanDocumentKey();
    return this.httpClient.post<PlanDocumentKeyResult>(url, { planNumber }, this.httpOptions);
  }

  // download doc based on plan doc key
  downloadPlanDocument(planNumber: string, planDocumentKey: PlanDocumentKey): Observable<Blob> {
    const encodeKey = encodeURIComponent(planDocumentKey.key);
    const encodeHash = encodeURIComponent(planDocumentKey.hash);

    const url = ApiRouter.downloadPlanDocument(planNumber, encodeKey, encodeHash);

    return this.httpClient.get(url, {
      ...this.httpOptions,
      responseType: 'blob', // makes it into downloadable file,
      observe: 'body',
      headers: new HttpHeaders({
        ...this.downloadHeaders,
      }),
    });
  }
}
